import { IRootState } from '../../../../store'
import { IInitiateIvState } from '../store/initiateIv.types'

export const getInitiateIvSelector = (state: IRootState): IInitiateIvState => state.initiateIv
